<template>
    <div>
        <form @submit.prevent="submit">
            <template v-if="isIdoso">
                <ModalVerificarPrivado
                    v-if="caractSaude.idoso.privado == 1 && status_privado == false"
                    @liberar="status_privado = true"
                />
                <div v-else class="col-md-9" v-on:mousemove="status_privado = !checkInactivity"> </div>
                <h2 class="mt-3">Linguagem</h2>
                <div class="row">
                    <form-select
                        v-model="caractSaude.idoso.dificuldade_fala"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta dificuldade na fala?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.compreende_perguntas"
                        :itens="$root.arrays.pergunta"
                        label="Compreende as perguntas que são feitas?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.dificuldade_expressar"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta dificuldade em se expressar?"
                        grid="6"
                    />
                </div>
                <h2 class="mt-3">Alimentação</h2>
                <div class="row">
                    <form-select
                        v-model="caractSaude.idoso.apetite"
                        :itens="$root.arrays.pergunta"
                        label="Tem bom apetite?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.recusa_alimentar"
                        :itens="$root.arrays.pergunta"
                        label="Recusa alimentação?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.restricao_alimentar"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta restrição a algum alimento?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.restricao_alimentar == 1"
                        v-model="caractSaude.idoso.restricao_alimentar_qual"
                        label="Se sim qual?"
                        placeholder="Restrição a algum Alimento"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.alergia_alimentar"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta alergia a algum alimento?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.alergia_alimentar == 1"
                        v-model="caractSaude.idoso.alergia_alimentar_qual"
                        label="Se sim qual?"
                        placeholder="Alergia a algum Alimento"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.ajudar_alimentar"
                        :itens="$root.arrays.pergunta"
                        label="Necessita de ajuda para se alimentar?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.sonda_alimentar"
                        :itens="$root.arrays.pergunta"
                        label="Faz uso de sonda para alimentação?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.preferencia_alimentar"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta  preferência alimentar?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.preferencia_alimentar == 1"
                        v-model="caractSaude.idoso.preferencia_alimentar_qual"
                        label="Se sim qual?"
                        placeholder="Qual preferência alimentar"
                        grid="6"
                    />
                </div>
                <h2 class="mt-3">Saúde</h2>
            
                <div class="row">
                    <form-select
                        v-model="caractSaude.idoso.cartao_vacina"
                        :itens="$root.arrays.pergunta"
                        label="Possui cartão de vacina?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.cartao_atualizado"
                        :itens="$root.arrays.pergunta"
                        label="O cartão está atualizado?"
                        grid="6"
                    />

                    <form-select
                        v-model="caractSaude.idoso.dificuldade_mobildiade"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta dificuldade de locomoção e/ou mobilidade reduzida?"
                        grid="6"
                    />

                    <form-select
                        v-model="caractSaude.idoso.equipamento_locomocao"
                        :itens="$root.arrays.pergunta"
                        label="Utiliza algum tipo de equipamento para apoio e locomoção?"
                        grid="6"
                    />

                    <form-select
                        v-model="caractSaude.idoso.equipamento_locomocao_qual"
                        :itens="$root.arrays.equipamento_locomocao"
                        label="Qual tipo de equipamento para apoio e locomoção?"
                        grid="6"
                    />

                    <form-input
                        v-if="caractSaude.idoso.equipamento_locomocao_qual == 6"
                        v-model="caractSaude.idoso.desc_equip_locomocao"
                        label="Descreva o equipamento para apoio e locomoção"
                        grid="6"
                    />

                    <form-select
                        v-model="caractSaude.idoso.sofreu_acidente"
                        :itens="$root.arrays.pergunta"
                        label="Sofreu algum acidente ou queda?"
                        grid="6"
                    />

                    <form-input
                        v-if="caractSaude.idoso.sofreu_acidente == 1"
                        v-model="caractSaude.idoso.acidente_reagiu"
                        label="Como reagiu?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.uso_ortese"
                        :itens="$root.arrays.pergunta"
                        label="Faz uso de órtese?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.uso_ortese == 1"
                        v-model="caractSaude.idoso.ortese_qual"
                        label="Qual?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.usa_protese"
                        :itens="$root.arrays.pergunta"
                        label="Faz uso de prótese?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.usa_protese == 1"
                        v-model="caractSaude.idoso.protese_qual"
                        label="Qual?"
                        grid="6"
                    />

                    <form-select
                        v-model="caractSaude.idoso.usa_oculos"
                        :itens="$root.arrays.pergunta"
                        label="Faz uso de óculos?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.doenca_ortopedica"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta doença ortopédica (pé chato, torto etc.)?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.doenca_ortopedica == 1"
                        v-model="caractSaude.idoso.doenca_ortopedica_qual"
                        label="Qual?"
                        grid="6"
                    />
                    <form-calendar
                        v-model="caractSaude.idoso.data_ultima_avaliacao"
                        grid="6"
                        label="Data da última avaliação/acompanhamento em qual serviço?"
                    />

                    <form-select
                        v-model="caractSaude.idoso.usa_fralda"
                        :itens="$root.arrays.pergunta"
                        label="Faz uso de fralda geriátrica?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.doenca_ossea"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta doença óssea"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.doenca_ossea == 1"
                        v-model="caractSaude.idoso.doenca_ossea_qual"
                        label="Qual?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.doenca_psiquiatrica"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta doença psiquiátrica ou psicológica?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.doenca_psiquiatrica == 1"
                        v-model="caractSaude.idoso.doenca_psiquiatrica_qual"
                        label="Qual?"
                        grid="6"
                    />
                    <form-calendar
                        v-if="caractSaude.idoso.doenca_psiquiatrica == 1"
                        v-model="caractSaude.idoso.data_inicio_tratamento"
                        grid="6"
                        label="Data Início do tratamento"
                    />
                    <form-select
                        v-if="caractSaude.idoso.doenca_psiquiatrica == 1"
                        v-model="caractSaude.idoso.doenca_psiq_instituicao"
                        label="Instituição"
                        :itens="$root.arrays.intituicao_psiquiatrica"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.doenca_psiquiatrica == 1"
                        v-model="caractSaude.idoso.referencia_tecnica"
                        grid="6"
                        label="Referência técnica se houve?"
                    />
                    <form-select
                        v-model="caractSaude.idoso.acomp_psicologico"
                        :itens="$root.arrays.pergunta"
                        label="Há indicação para acompanhamento psicológico?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.acomp_psicologico_esteve"
                        :itens="$root.arrays.pergunta"
                        label="Esteve ou está em acompanhamento psicológico? "
                        grid="6"
                    />

                    <form-input
                        v-if="caractSaude.idoso.acomp_psicologico_esteve == 1"
                        v-model="caractSaude.idoso.acomp_psicologico_esteve_tempo"
                        label="Há quanto tempo:"
                        grid="6"
                    />

                    <form-select
                        v-model="caractSaude.idoso.doenca_renal"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta doenças renais"
                        grid="6"
                    />

                    <form-input
                        v-if="caractSaude.idoso.doenca_renal == 1"
                        v-model="caractSaude.idoso.doenca_renal_qual"
                        label="Qual?"
                        grid="6"
                    />

                    <form-select
                        v-model="caractSaude.idoso.tem_comorbidade"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta algum tipo de comorbidade (ex: diabetes, pressão alta, doenças cardiovasculares)?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.tem_comorbidade == 1"
                        v-model="caractSaude.idoso.tem_comorbidade_qual"
                        label="Qual?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.outra_doenca"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta alguma outra doença?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.outra_doenca == 1"
                        v-model="caractSaude.idoso.outra_doenca_qual"
                        label="Qual?"
                        grid="6"
                    />

                    <form-select
                        v-model="caractSaude.idoso.apresenta_alergia"
                        :itens="$root.arrays.pergunta"
                        label="Apresenta algum tipo de alergia?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.apresenta_alergia == 1"
                        v-model="caractSaude.idoso.alergia_qual"
                        label="Qual?"
                        grid="6"
                    />

                    <form-select
                        v-model="caractSaude.idoso.historico_avc"
                        :itens="$root.arrays.pergunta"
                        label="Possui histórico de acidente cerebral vascular (AVC)?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.historico_avc == 1"
                        v-model="caractSaude.idoso.historico_avc_periodo"
                        label="Período?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.historico_infarto"
                        :itens="$root.arrays.pergunta"
                        label="Possui histórico de infarto?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.historico_infarto == 1"
                        v-model="caractSaude.idoso.historico_infarto_periodo"
                        label="Período?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.uso_prolongado_med"
                        :itens="$root.arrays.pergunta"
                        label="Faz uso constante ou  prolongado de medicamentos?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.uso_prolongado_med == 1"
                        v-model="caractSaude.idoso.uso_prolongado_med_quais"
                        label="Quais?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.cuidado_especial"
                        :itens="$root.arrays.pergunta"
                        label="Precisa de algum cuidado especial por motivo de saúde?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.cuidado_especial == 1"
                        v-model="caractSaude.idoso.cuidado_especial_periodo"
                        label="Período?"
                        grid="6"
                    />
                    <form-select
                        v-model="caractSaude.idoso.atendimento_medico_especializado"
                        :itens="$root.arrays.pergunta"
                        label="É necessário encaminhamento para Atendimento médico especializado?"
                        grid="6"
                    />
                    <form-input
                        v-if="caractSaude.idoso.atendimento_medico_especializado == 1"
                        v-model="caractSaude.idoso.at_medico_especializado_quais"
                        label="Quais?"
                        grid="6"
                    />
                </div>

                <div class="row pt-4 px-0 d-flex justify-content-end">
                    <form-toggle
                        grid="4"
                        class="d-flex justify-content-end"
                        mt="0"
                        v-model="caractSaude.idoso.privado"
                        label="Sigilo?"
                    />
                    <div class="col-auto px-2 text-right">
                        <button class="btn btn-success btn-submit" type="submit">
                            <i class="mdi mdi-content-save" />
                            {{ $t("Salvar") }}
                        </button>
                    </div>
                </div>

            </template>

            <template v-else>
                <div class="row">
                    <div class="col-12">

                        <template v-if="todasPessoas.length > 1">
                            <h3>Pessoas Vinculadas ao Acolhimento:</h3>

                            <b-table :items="todasPessoas" :fields="['nome', 'idade', 'parentesco']" small responsive>
                                <template #cell(nome)="row">
                                    <a href="#" @click.prevent="selecionarPessoa(row.item)">
                                        {{ row.item.nome }}
                                    </a>
                                </template>
                            </b-table>
                        </template>

                        <div
                            v-if="pessoaSelecionada"
                            :class="{ 'mt-4': todasPessoas.length > 1 }"
                        >

                            <ModalVerificarPrivado
                                v-if="caractSaudeSelecionada.privado == 1 && status_privado == false"
                                @liberar="status_privado = true"
                            /> 

                            <div v-else class="col-md-9" v-on:mousemove="status_privado = !checkInactivity"> </div>

                            <h3> Saúde e Desenvolvimento de: {{ pessoaSelecionada.nome }}</h3>
                            
                            <h2 class="mt-3">Linguagem</h2>
                            <div class="row">
                                <form-select
                                    v-model="caractSaudeSelecionada.dificuldade_fala"
                                    :itens="$root.arrays.pergunta"
                                    label="Apresenta dificuldade na fala?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.compreende_perguntas"
                                    :itens="$root.arrays.pergunta"
                                    label="Compreende as perguntas que são feitas?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.dificuldade_expressar"
                                    :itens="$root.arrays.pergunta"
                                    label="Apresenta dificuldade em se expressar?"
                                    grid="6"
                                />
                            </div>
                            <h2 class="mt-3">Alimentação</h2>
                            <div class="row">
                                <form-select
                                    v-model="caractSaudeSelecionada.alergia_alimentar"
                                    :itens="$root.arrays.pergunta"
                                    label="Tem restrição ou apresenta alergia a algum alimento?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.alergia_alimentar == 1"
                                    v-model="caractSaudeSelecionada.alergia_alimentar_qual"
                                    label="Informe qual(s) alimento(s)"
                                    placeholder="Informe qual(s) alimento(s)"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.preferencia_alimentar"
                                    :itens="$root.arrays.pergunta"
                                    label="Faz uso de alimentação especial?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.preferencia_alimentar == 1"
                                    v-model="caractSaudeSelecionada.preferencia_alimentar_qual"
                                    label="Informe a alimentação especial"
                                    placeholder="Informe a alimentação especial"
                                    grid="6"
                                />
                            </div>
                            <h2 class="mt-3">Saúde</h2>
                        
                            <div class="row">
                                <form-select
                                    v-model="caractSaudeSelecionada.cartao_vacina"
                                    :itens="$root.arrays.pergunta"
                                    label="Possui cartão de vacina?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.cartao_atualizado"
                                    :itens="$root.arrays.pergunta"
                                    label="O cartão está atualizado?"
                                    grid="6"
                                />

                                <form-select
                                    v-model="caractSaudeSelecionada.dificuldade_mobildiade"
                                    :itens="$root.arrays.pergunta"
                                    label="Apresenta dificuldade de locomoção e/ou mobilidade reduzida?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.equipamento_locomocao"
                                    :itens="$root.arrays.pergunta"
                                    label="Utiliza algum tipo de equipamento para apoio e locomoção?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.equipamento_locomocao_qual"
                                    :itens="$root.arrays.equipamento_locomocao"
                                    label="Qual tipo de equipamento para apoio e locomoção?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.equipamento_locomocao_qual == 6"
                                    v-model="caractSaudeSelecionada.desc_equip_locomocao"
                                    label="Descreva o equipamento para apoio e locomoção"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.sofreu_acidente"
                                    :itens="$root.arrays.pergunta"
                                    label="Sofreu algum acidente ou queda?"
                                    grid="6"
                                />

                                <form-select
                                    v-model="caractSaudeSelecionada.uso_ortese"
                                    :itens="$root.arrays.pergunta"
                                    label="Faz uso de órtese?"
                                    grid="6"
                                />

                                <form-input
                                    v-if="caractSaudeSelecionada.uso_ortese == 1"
                                    v-model="caractSaudeSelecionada.ortese_qual"
                                    label="Qual?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.usa_protese"
                                    :itens="$root.arrays.pergunta"
                                    label="Faz uso de prótese?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.usa_protese == 1"
                                    v-model="caractSaudeSelecionada.protese_qual"
                                    label="Qual?"
                                    grid="6"
                                />

                                <form-select
                                    v-model="caractSaudeSelecionada.usa_oculos"
                                    :itens="$root.arrays.pergunta"
                                    label="Faz uso de óculos?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.doenca_psiquiatrica"
                                    :itens="$root.arrays.pergunta"
                                    label="Apresenta doença psiquiátrica ou psicológica?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.doenca_psiquiatrica == 1"
                                    v-model="caractSaudeSelecionada.doenca_psiquiatrica_qual"
                                    label="Qual?"
                                    grid="6"
                                />
                                <form-calendar
                                    v-if="caractSaudeSelecionada.doenca_psiquiatrica == 1"
                                    v-model="caractSaudeSelecionada.data_inicio_tratamento"
                                    grid="6"
                                    label="Data Início do tratamento"
                                />
                                <form-select
                                    v-if="caractSaudeSelecionada.doenca_psiquiatrica == 1"
                                    v-model="caractSaudeSelecionada.doenca_psiq_instituicao"
                                    label="Instituição"
                                    :itens="$root.arrays.intituicao_psiquiatrica"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.doenca_psiquiatrica == 1"
                                    v-model="caractSaudeSelecionada.referencia_tecnica"
                                    grid="6"
                                    label="Referência técnica se houve?"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.acomp_psicologico"
                                    :itens="$root.arrays.pergunta"
                                    label="Há indicação para acompanhamento psicológico?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.acomp_psicologico_esteve"
                                    :itens="$root.arrays.pergunta"
                                    label="Esteve ou está em acompanhamento psicológico? "
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.acomp_psicologico_esteve == 1"
                                    v-model="caractSaudeSelecionada.acomp_psicologico_esteve_tempo"
                                    label="Há quanto tempo:"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.tem_comorbidade"
                                    :itens="$root.arrays.pergunta"
                                    label="Apresenta algum tipo de comorbidade (ex: diabetes, pressão alta, doenças cardiovasculares)?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.tem_comorbidade == 1"
                                    v-model="caractSaudeSelecionada.tem_comorbidade_qual"
                                    label="Qual?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.outra_doenca"
                                    :itens="$root.arrays.pergunta"
                                    label="Apresenta alguma outra doença?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.outra_doenca == 1"
                                    v-model="caractSaudeSelecionada.outra_doenca_qual"
                                    label="Qual?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.apresenta_alergia"
                                    :itens="$root.arrays.pergunta"
                                    label="Apresenta algum tipo de alergia?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.apresenta_alergia == 1"
                                    v-model="caractSaudeSelecionada.alergia_qual"
                                    label="Qual?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.historico_avc"
                                    :itens="$root.arrays.pergunta"
                                    label="Possui histórico de acidente cerebral vascular (AVC)?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.historico_avc == 1"
                                    v-model="caractSaudeSelecionada.historico_avc_periodo"
                                    label="Período?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.historico_infarto"
                                    :itens="$root.arrays.pergunta"
                                    label="Possui histórico de infarto?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.historico_infarto == 1"
                                    v-model="caractSaudeSelecionada.historico_infarto_periodo"
                                    label="Período?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.uso_prolongado_med"
                                    :itens="$root.arrays.pergunta"
                                    label="Faz uso constante ou prolongado de medicamentos?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.uso_prolongado_med == 1"
                                    v-model="caractSaudeSelecionada.uso_prolongado_med_quais"
                                    label="Quais?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.cuidado_especial"
                                    :itens="$root.arrays.pergunta"
                                    label="Precisa de algum cuidado especial por motivo de saúde?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.cuidado_especial == 1"
                                    v-model="caractSaudeSelecionada.cuidado_especial_periodo"
                                    label="Período?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.atendimento_medico_especializado"
                                    :itens="$root.arrays.pergunta"
                                    label="É necessário encaminhamento para Atendimento médico especializado?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractSaudeSelecionada.atendimento_medico_especializado == 1"
                                    v-model="caractSaudeSelecionada.at_medico_especializado_quais"
                                    label="Quais?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractSaudeSelecionada.substancias_psicoativas"
                                    :itens="$root.arrays.substancias_psicoativas"
                                    label="Faz uso de substâncias psicoativas?"
                                    grid="6"
                                />
                            </div>
                            <div class="row pt-4 px-0 d-flex justify-content-end">
                                <form-toggle
                                    grid="4"
                                    class="d-flex justify-content-end"
                                    mt="0"
                                    v-model="caractSaudeSelecionada.privado"
                                    label="Sigilo?"
                                />
                                <div class="col-auto px-2 text-right">
                                    <button class="btn btn-success btn-submit" type="submit">
                                        <i class="mdi mdi-content-save" />
                                        {{ $t("Salvar") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </form>
    </div>
</template>
<script>

import ModalVerificarPrivado from "../../includes/ModalVerificarPrivado";

export default {
    components: {
        ModalVerificarPrivado,
    },
    props: ["item"],
    data() {
        return { 
            caractSaude: {},
            caractSaudeSelecionada: null,
            pessoaReferencia: [],
            pessoaSelecionada: null,
            status_privado: false,
        };
    },
    watch: {
        item: {
            immediate: true,
            handler(newVal) {
            if (newVal.caractSaude) {
                this.caractSaude.idoso = newVal.caractSaude.idoso
                ? this.preencherCamposZerados(newVal.caractSaude.idoso)
                : this.preencherCamposZerados(null);
                this.caractSaude.pessoasVinculadas = newVal.caractSaude.pessoasVinculadas || [];
            } else {
                this.caractSaude.idoso = this.preencherCamposZerados(null);
                this.caractSaude.pessoasVinculadas = [];
            }

            this.pessoaReferencia = newVal.pessoaReferencia || [];
            }
        },
        todasPessoas: {
            immediate: true,
            handler(pessoas) {
                if (!this.isIdoso && pessoas.length === 1) {
                    this.selecionarPessoa(pessoas[0]);
                }
            }
        }
    },
    computed: {
        checkInactivity() {
            if (this.$root.isIdle == true) {
                this.status_privado = false;
                this.$bvModal.show("verificar-acolhimento-privado");
            }
            return this.$root.isIdle;
        },
        todasPessoas() {
            const pessoaPrincipal = {
                id: 'principal',
                nome: this.item.nome_acolhido,
                idade: this.calcularIdade(this.item.nascimento),
                parentesco: 'Acolhido(a)',
                tipo_cadastro: 'Principal',
            };

            const vinculados = this.pessoaReferencia.filter(
                p => p.tipo_cadastro === 'Familiar' || p.tipo_cadastro === 'Crianca'
            );

            return [pessoaPrincipal, ...vinculados];
        },
        isIdoso() {

            const hoje = moment();
            const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
            const idade = hoje.diff(nascimento, 'years');

            // Se existir público alvo, verifica se é 8, senão usa idade para decidir
            return this.item.solicitacao?.publico_alvo_id === 8 || idade >= 60;
        },
        saudeAtual() {
            return this.pessoaSelecionada ? this.caractSaudeSelecionada : this.caractSaude;
        }
    },
    methods: {
        calcularIdade(dataNasc) {
            if (!dataNasc) return null;
            const hoje = new Date();
            const nasc = new Date(dataNasc);
            let idade = hoje.getFullYear() - nasc.getFullYear();
            const m = hoje.getMonth() - nasc.getMonth();
            if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) {
                idade--;
            }
            return idade;
        },
        preencherCamposZerados(obj) {
            const campos = [
                'dificuldade_fala',
                'compreende_perguntas',
                'dificuldade_expressar',
                'apetite',
                'recusa_alimentar',
                'restricao_alimentar',
                'alergia_alimentar',
                'ajudar_alimentar',
                'sonda_alimentar',
                'preferencia_alimentar',
                'cartao_vacina',
                'cartao_atualizado',
                'dificuldade_mobildiade',
                'equipamento_locomocao',
                'sofreu_acidente',
                'uso_ortese',
                'usa_protese',
                'usa_oculos',
                'doenca_ortopedica',
                'usa_fralda',
                'doenca_ossea',
                'doenca_psiquiatrica',
                'acomp_psicologico',
                'acomp_psicologico_esteve',
                'doenca_renal',
                'tem_comorbidade',
                'outra_doenca',
                'apresenta_alergia',
                'historico_avc',
                'historico_infarto',
                'uso_prolongado_med',
                'cuidado_especial',
                'atendimento_medico_especializado',
                'substancias_psicoativas'
            ];

            if (!obj) obj = {};

            campos.forEach(campo => {
                if (obj[campo] === null || obj[campo] === undefined || obj[campo] === 0) {
                    obj[campo] = null;
                }
            });

            return obj;
        },

        selecionarPessoa(pessoa) {
            this.pessoaSelecionada = pessoa;

            if (pessoa.tipo_cadastro === 'Principal') {

                this.caractSaudeSelecionada = { ...this.caractSaude.idoso };

            }else{

                // Tenta achar os dados de saúde da pessoa selecionada
                const dadosSaude = this.item.caractSaude?.pessoasVinculadas?.find(
                    cs => cs.pessoa_referencia_id === pessoa.id
                );

                // Se existir, usa esses dados para preencher caractSaudeSelecionada
                this.caractSaudeSelecionada = dadosSaude ? { ...dadosSaude } : {
                    pessoa_referencia_id: pessoa.id,
                    dificuldade_fala: null,
                    compreende_perguntas: null,
                    dificuldade_expressar: null,
                    apetite: null,
                    recusa_alimentar: null,
                    restricao_alimentar: null,
                    alergia_alimentar: null,
                    ajudar_alimentar: null,
                    sonda_alimentar: null,
                    preferencia_alimentar: null,
                    cartao_vacina: null,
                    cartao_atualizado: null,
                    dificuldade_mobildiade: null,
                    equipamento_locomocao: null,
                    sofreu_acidente: null,
                    uso_ortese: null,
                    usa_protese: null,
                    usa_oculos: null,
                    doenca_ortopedica: null,
                    usa_fralda: null,
                    doenca_ossea: null,
                    doenca_psiquiatrica: null,
                    acomp_psicologico: null,
                    acomp_psicologico_esteve: null,
                    doenca_renal: null,
                    tem_comorbidade: null,
                    outra_doenca: null,
                    apresenta_alergia: null,
                    historico_avc: null,
                    historico_infarto: null,
                    uso_prolongado_med: null,
                    cuidado_especial: null,
                    atendimento_medico_especializado: null,
                    substancias_psicoativas: null
                };

            }
            
        },
        formatarData(data) {
            if (!data) return '';
            const d = new Date(data);
            const dia = ('0' + d.getDate()).slice(-2);
            const mes = ('0' + (d.getMonth() + 1)).slice(-2);
            const ano = d.getFullYear();
            return `${dia}/${mes}/${ano}`;
        },
        verificarValueArray(value, array, valueIsArray = false) {
            if (valueIsArray && value) {
                var a = "";
                for (var i = 0; i < value.length; i++) {
                    const result = array.filter(item => item.id == value[i]);
                    a += result[0].value + (i < value.length - 1 ? "," : "");
                }
                return a;
            } else {
                const result = array.filter(item => item.id == value);
                return result[0] ? result[0].value : "";
            }
        },
        submit() {
            const camposBooleanos = [
                'dificuldade_fala',
                'compreende_perguntas',
                'dificuldade_expressar',
                'apetite',
                'recusa_alimentar',
                'restricao_alimentar',
                'alergia_alimentar',
                'ajudar_alimentar',
                'sonda_alimentar',
                'preferencia_alimentar',
                'cartao_vacina',
                'cartao_atualizado',
                'dificuldade_mobildiade',
                'equipamento_locomocao',
                'sofreu_acidente',
                'uso_ortese',
                'usa_protese',
                'usa_oculos',
                'doenca_ortopedica',
                'usa_fralda',
                'doenca_ossea',
                'doenca_psiquiatrica',
                'acomp_psicologico',
                'acomp_psicologico_esteve',
                'doenca_renal',
                'tem_comorbidade',
                'outra_doenca',
                'apresenta_alergia',
                'historico_avc',
                'historico_infarto',
                'uso_prolongado_med',
                'cuidado_especial',
                'atendimento_medico_especializado',
                'substancias_psicoativas'
            ];

            // Campos texto que não podem ser null
            const camposTexto = [
                'restricao_alimentar_qual',
                'alergia_alimentar_qual',
                'preferencia_alimentar_qual',
                'equipamento_locomocao_qual',
                'acidente_reagiu',
                'protese_qual',
                'doenca_ortopedica_qual',
                'doenca_ossea_qual',
                'doenca_psiquiatrica_qual',
                'referencia_tecnica',
                'doenca_renal_qual',
                'tem_comorbidade_qual',
                'outra_doenca_qual',
                'alergia_qual',
                'historico_avc_periodo',
                'historico_infarto_periodo',
                'uso_prolongado_med_quais',
                'cuidado_especial_periodo',
                'at_medico_especializado_quais',
                'ortese_qual'
            ];

            // Ajusta campos booleanos para 0 se não forem 1 ou 2
            if (this.caractSaude.idoso) {
                camposBooleanos.forEach(campo => {
                    if (this.caractSaude.idoso[campo] !== 1 && this.caractSaude.idoso[campo] !== 2) {
                        this.caractSaude.idoso[campo] = null;
                    }
                });

                // Ajusta campos texto para string vazia se null ou undefined
                camposTexto.forEach(campo => {
                    if (this.caractSaude.idoso[campo] === null || this.caractSaude.idoso[campo] === undefined) {
                        this.caractSaude.idoso[campo] = "";
                    }
                });
            }

            if (this.caractSaudeSelecionada) {
                camposBooleanos.forEach(campo => {
                    if (this.caractSaudeSelecionada[campo] !== 1 && this.caractSaudeSelecionada[campo] !== 2) {
                        this.caractSaudeSelecionada[campo] = null;
                    }
                });

                camposTexto.forEach(campo => {
                    if (this.caractSaudeSelecionada[campo] === null || this.caractSaudeSelecionada[campo] === undefined) {
                        this.caractSaudeSelecionada[campo] = "";
                    }
                });
            }

            if (this.pessoaSelecionada) {
                if (this.pessoaSelecionada.tipo_cadastro === 'Principal') {
                    this.caractSaude.idoso = { ...this.caractSaudeSelecionada };
                } else {
                    this.pessoaSelecionada.caracteristica_saude = { ...this.caractSaudeSelecionada };
                }
            }

            this.item.caractSaude = {
                idoso: this.caractSaude.idoso,
                pessoasVinculadas: this.pessoaReferencia
                    .filter(p => p.caracteristica_saude)
                    .map(p => ({
                        ...p.caracteristica_saude,
                        pessoa_referencia_id: p.id,
                    }))
            };

            this.$emit("submit");
        }
    },
    mounted() {
        if (this.item.caractSaude) {
            this.caractSaude = {
                idoso: this.preencherCamposZerados(this.item.caractSaude.idoso),
                pessoasVinculadas: this.item.caractSaude.pessoasVinculadas || []
            };
        } else {
            this.caractSaude = {
                idoso: this.preencherCamposZerados(null),
                pessoasVinculadas: []
            };
        }

        if (this.item.pessoaReferencia != null) {
            this.pessoaReferencia = this.item.pessoaReferencia;
        }
    },
};
</script>
